import { Routes, RouterModule } from '@angular/router';
import { FormConfigurationScreenComponent } from './form-configuration.component';

const formConfigurationRoutes: Routes = [
];

export const FormConfigurationRouter = RouterModule.forChild(formConfigurationRoutes);